import { Stack } from '@mui/material';

import { UnifiedConnectionDtoProvider, NylasGrantDtoProvider } from '@/api/generated';
import ConnectedIcon from '@/assets/integrations/connected-icon.svg?react';
import { UnifiedIntegrationCategory } from '@/mappings/unifiedIntegrationsAuth';
import { UnifiedIntegrationProvider } from '@/mappings/unifiedIntegrationsAuth';

import {
  CategoryTitle,
  ConnectButton,
  ConnectButtonText,
  IntegrationContainer,
  IntegrationFooter,
  IntegrationLogos,
  IntegrationsCategory,
  IntegrationsRow,
  LogoContainer,
  ProviderTitle,
  ComingSoon
} from '../IntegrationsStyles';

interface GeneralIntegrationsProps {
  unifiedIntegrationsAuth: UnifiedIntegrationCategory[];
  isConnected: (provider: UnifiedConnectionDtoProvider | string) => boolean;
  onDisconnect: (provider: NylasGrantDtoProvider | UnifiedIntegrationProvider | string) => void;
  connectToUnifiedProvider: (provider: UnifiedIntegrationProvider) => void;
}

const GeneralIntegrations = ({
  unifiedIntegrationsAuth,
  isConnected,
  onDisconnect,
  connectToUnifiedProvider
}: GeneralIntegrationsProps) => {
  return unifiedIntegrationsAuth.map(category => (
    <IntegrationsCategory key={category.name}>
      <CategoryTitle>{category.name}</CategoryTitle>
      <IntegrationsRow>
        {category.providers.map(provider => (
          <IntegrationContainer disabled={!provider.active} key={provider.type}>
            <IntegrationLogos>
              <LogoContainer>{provider.logo}</LogoContainer>
            </IntegrationLogos>

            <IntegrationFooter>
              <Stack direction="row" alignItems="center" gap={1}>
                <ProviderTitle>{provider.name}</ProviderTitle>
                {isConnected(provider.type) && <ConnectedIcon width="15px" height="15px" />}
              </Stack>

              {provider.active ? (
                isConnected(provider.type) ? (
                  <ConnectButton onClick={() => onDisconnect(provider)}>
                    <ConnectButtonText>Disconnect</ConnectButtonText>
                  </ConnectButton>
                ) : (
                  <ConnectButton onClick={() => connectToUnifiedProvider(provider)}>
                    <ConnectButtonText>Connect</ConnectButtonText>
                  </ConnectButton>
                )
              ) : (
                <Stack padding="8px 12px">
                  <ComingSoon>Coming soon...</ComingSoon>
                </Stack>
              )}
            </IntegrationFooter>
          </IntegrationContainer>
        ))}
      </IntegrationsRow>
    </IntegrationsCategory>
  ));
};

export default GeneralIntegrations;
